import { FC, SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

const UpIcon: FC<IconProps> = props => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='10'
      height='10'
      viewBox='0 0 16 16'
      fill='none'
      {...props}
    >
      <path
        d='M13.334 10.668L8.00065 5.33464L2.66732 10.668'
        stroke='#9E9E9E'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

UpIcon.displayName = 'UpIcon';
export default UpIcon;
